export default __webpack_public_path__ + "assets/icons/trash-2.f58e6b2e.svg";